import { Dot } from 'lucide-react';
import { Link } from 'react-router';
import * as React from 'react';

export const FooterLinks = () => {
  return (
    <div className="flex space-x-1 items-center text-muted-foreground">
      <Link
        className="text-sm font-semibold hover:text-muted-foreground/75"
        to="/"
      >
        FlagSync
      </Link>
      <Dot className="h-4 w-4 text-muted-foreground" />
      <Link
        className="text-sm font-semibold hover:text-muted-foreground/75"
        to="/support"
      >
        Support
      </Link>
    </div>
  );
};
